import { render, staticRenderFns } from "./AnalyticsTalent.vue?vue&type=template&id=4a25edfe&"
import script from "./AnalyticsTalent.vue?vue&type=script&lang=js&"
export * from "./AnalyticsTalent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports